import { render } from "./DestinoIntermediario.vue?vue&type=template&id=031abbed"
import script from "./DestinoIntermediario.vue?vue&type=script&lang=js"
export * from "./DestinoIntermediario.vue?vue&type=script&lang=js"

import "../css/transporte.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__